import React from 'react';

const NamePlate = () => {
    return (
        <div className="height-5 width-100 blue darken-2 candidate-container" >
            <div className="candidate">
                <h1 className="name">
                    <span className="first-name">Pawan</span>
                    <span className="last-name">Choudhari</span>
                </h1>
                <h5 className="designation">Web Developer</h5>
            </div>
        </div>
    )
};

export default NamePlate;
